import React from "react";
import TestimonialCard from "./TestimonialCard";

const TestimonialsSection = () => {
  const testimonials = [
    {
      rating: 5,
      content:
        "Their technicians were prompt, professional, and solved our AC issues quickly. Couldn't be happier with the service.",
      name: "Sarah Johnson",
      title: "Residential Customer"
    },
    {
      rating: 5,
      content:
        "We've been using CoolAir for all our office building HVAC needs for years. Their maintenance program has saved us thousands.",
      name: "Mark Williams",
      title: "Business Owner"
    },
    {
      rating: 5,
      content:
        "The new heating system they installed is so much more efficient than our old one. Our utility bills have decreased significantly.",
      name: "Jennifer Garcia",
      title: "Homeowner"
    }
  ];

  return (
    <section id="testimonials" className="py-16 bg-blue-50">
      <div className="container mx-auto px-4 text-center">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">What Our Customers Say</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We take pride in our work and our customers' satisfaction is our
            priority.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              rating={testimonial.rating}
              content={testimonial.content}
              name={testimonial.name}
              title={testimonial.title}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
